export default __webpack_public_path__ + "static/media/configuracion.1cac6989.svg";